import { useState, useEffect, useCallback } from 'react';
import {
  pickInitialActiveFolderId,
  persistActiveFolderId,
  readActiveFolderId,
  subscribeActiveFolderChanges,
} from '../../../utils/activeFolderStorage';

const monthNames = [
  'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
  'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık',
];

export const upsertDistributionInFolders = (prevFolders, folderId, index, distributionToSave) =>
  prevFolders.map((folder) => {
    if (folder.id !== folderId) return folder;
    const next = [...folder.distributions];
    if (index === -1) next.push(distributionToSave);
    else next[index] = distributionToSave;
    return { ...folder, distributions: next };
  });

export const useDistributionFolders = () => {
  const [folders, setFolders] = useState([]);
  const [activeFolder, setActiveFolderState] = useState(null);

  // Public setter — state'i günceller, localStorage'a yazar ve custom event ile
  // başka komponent instance'larına da senkron olur.
  const setActiveFolder = useCallback((folderId) => {
    setActiveFolderState(folderId);
    persistActiveFolderId(folderId);
  }, []);

  const createDefaultFolder = useCallback(() => {
    const currentDate = new Date();
    const folderName = `${monthNames[currentDate.getMonth()]} ${currentDate.getFullYear()}`;
    const newFolder = {
      id: Date.now(),
      name: folderName,
      distributions: [],
    };
    setFolders([newFolder]);
    setActiveFolderState(newFolder.id);
    persistActiveFolderId(newFolder.id);
    localStorage.setItem('distributionFolders', JSON.stringify([newFolder]));
    return newFolder;
  }, []);

  useEffect(() => {
    const foldersString = localStorage.getItem('distributionFolders');
    if (foldersString) {
      const loadedFolders = JSON.parse(foldersString);
      setFolders(loadedFolders);
      setActiveFolderState(pickInitialActiveFolderId(loadedFolders));
    } else {
      createDefaultFolder();
    }

    // Başka komponent (örn. SavedDistributions) aktif klasörü değiştirdiğinde
    // bu instance'ı da senkron tut.
    return subscribeActiveFolderChanges(() => {
      setActiveFolderState((prev) => {
        const next = readActiveFolderId();
        return prev === next ? prev : next;
      });
    });
  }, [createDefaultFolder]);

  return {
    folders,
    setFolders,
    activeFolder,
    setActiveFolder,
    createDefaultFolder,
  };
};
